import { render, staticRenderFns } from "./SpamMxs.vue?vue&type=template&id=d5b5798c&scoped=true"
import script from "./SpamMxs.vue?vue&type=script&lang=js"
export * from "./SpamMxs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b5798c",
  null
  
)

export default component.exports